import Accordion from '../../generic/Accordion';
import Card from '../../generic/Card/Card';
import Flex from '../../generic/Flex';

import BackfillIssueSanitizedLocators from './BackfillIssueSanitizedLocators';
import BackfillLicenseIdentificationDataCard from './BackfillLicenseIdentificationDataCard';
import BackfillSBOMSummaryData from './BackfillSBOMSummaryData';
import IssueCountBackfillCard from './IssueCountBackfillCard';

export const BackfillCard = () => {
  return (
    <Card isFullWidth padding="medium">
      <Card.Content>
        <Accordion id="backfill-org-data" isInitiallyOpen={false}>
          <Accordion.Target>Backfill Org Data</Accordion.Target>
          <Accordion.Body>
            <Flex direction="column" gap={12}>
              <BackfillLicenseIdentificationDataCard />
              <BackfillSBOMSummaryData />
              <BackfillIssueSanitizedLocators />
              <IssueCountBackfillCard />
            </Flex>
          </Accordion.Body>
        </Accordion>
      </Card.Content>
    </Card>
  );
};
